// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Support_pageWrap__Exys7 {
  padding: 4px 4px 32px;
}

.Support_desktopTable__E\\+sza {
  display: block;
}

.Support_mobileList__zv5N2 {
  display: none;
}

@media (max-width: 767px) {
  .Support_desktopTable__E\\+sza {
    display: none;
  }
  .Support_mobileList__zv5N2 {
    display: block;
  }
}

/* =========================================================
   Toolbar
   ========================================================= */
.Support_toolbarRow__rBIiK {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.Support_searchInput__GMeSO {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 320px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.Support_searchInput__GMeSO:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

/* =========================================================
   Status pills
   ========================================================= */
.Support_pillBase__PO\\+65 {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.Support_pillGreen__DG9SR { background: #E9F9EF; color: #16A34A; }
.Support_pillRed__A0kKm { background: #FDEDED; color: #DC2626; }
.Support_pillAmber__W8byj { background: #FFF7E6; color: #B45309; }
.Support_pillBlue__5LSmG { background: #EAF1FF; color: #2563EB; }
.Support_pillGrey__l2EMQ { background: #F1F2F6; color: #6B7280; }

.Support_emptyState__HqlB1 {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.Support_mobileCard__zypth {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.Support_mobileRow__xsZck {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.Support_mobileLabel__q3PHJ {
  min-width: 130px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.Support_mobileValue__X2QG4 {
  color: #1F2430;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/pages/support/Support.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,4BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,0BAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,4BAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,2BAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,2BAAY,mBAAmB,EAAE,cAAc,EAAE;;AAEjD;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 320px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillAmber { background: #FFF7E6; color: #B45309; }\n.pillBlue { background: #EAF1FF; color: #2563EB; }\n.pillGrey { background: #F1F2F6; color: #6B7280; }\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 130px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `Support_pageWrap__Exys7`,
	"desktopTable": `Support_desktopTable__E+sza`,
	"mobileList": `Support_mobileList__zv5N2`,
	"toolbarRow": `Support_toolbarRow__rBIiK`,
	"searchInput": `Support_searchInput__GMeSO`,
	"pillBase": `Support_pillBase__PO+65`,
	"pillGreen": `Support_pillGreen__DG9SR`,
	"pillRed": `Support_pillRed__A0kKm`,
	"pillAmber": `Support_pillAmber__W8byj`,
	"pillBlue": `Support_pillBlue__5LSmG`,
	"pillGrey": `Support_pillGrey__l2EMQ`,
	"emptyState": `Support_emptyState__HqlB1`,
	"mobileCard": `Support_mobileCard__zypth`,
	"mobileRow": `Support_mobileRow__xsZck`,
	"mobileLabel": `Support_mobileLabel__q3PHJ`,
	"mobileValue": `Support_mobileValue__X2QG4`
};
export default ___CSS_LOADER_EXPORT___;
